<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        class="woom-bike-outline woom-off-air"
        viewBox="0 0 800 600"
        style="enable-background: new 0 0 800 600"
        xml:space="preserve"
        v-once>
        <g class="bike">
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M286.8,412c-10.6,56.2-59.6,97.5-118.9,97.5c-66.9,0-121.2-54.3-121.2-121.2S101,267,168,267
				c39.4,0,73.7,18,95.9,47.1" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M269.5,321.2c13,19.3,19.6,42,19.6,67.1c0,2.6,0,4.3-0.2,6.9" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M309.1,414.7c-12,67.1-70.5,117.1-141.1,117.1c-79.3,0-143.6-64.3-143.6-143.6S88.7,244.6,168,244.6
				c46.8,0,88.3,22.4,114.5,57" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M288.1,309.5c15.2,22.8,23.5,49.3,23.5,78.7c0,3.2,0,5.5-0.3,8.7" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M585.1,277.4c15.1-6.7,31.7-10.4,49.3-10.4c66.9,0,121.2,54.3,121.2,121.2s-54.3,121.2-121.2,121.2
				s-121.2-54.3-121.2-121.2c0-41.7,21-78.4,53-100.2" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M572,258.9c1.3-0.6,1.9-0.9,3.1-1.5" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M581.1,254.8c16.7-6.8,34.2-10.2,53.3-10.2c79.3,0,143.6,64.3,143.6,143.6s-64.3,143.6-143.6,143.6
				s-143.6-64.3-143.6-143.6c0-52,26.9-97.1,68.3-122.3" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M269.5,321.2c-38.4,24.8-89.4,57.6-90.9,58.4c-4.3,2.4-6.8,7.2,1.1,7.8c5.1,0.4,166.9,12.5,166.9,12.5
				s-14.5-53.1-18.3-64.4c-3.8-11.4-16.5-41.7-16.5-41.7S293,306,269.5,321.2" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M364.9,385.2l-46.3-114.7c0,0,32.3-5.9,43.1-8.7c10.7-2.8,30.7-16.1,35.6-19.7c4.8-3.6,112.1-74.6,112.1-74.6
				l3.4,7c0,0-7.7,7.4-11.4,11.8c-3.7,4.4-25.9,35.5-34.8,48.7S364.9,385.2,364.9,385.2z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M371.1,410.2c0,0,130.3-193.3,133-195.4c2.8-2.1,9.5-9.2,14.2-11.5s4.7-2.3,4.7-2.3l2.7,6.4l19.8-8.5
				l-25.8-59.2l-19.7,8l0.9,2c0,0-127.8,89.4-130.8,91.4s-14.7,8-30.9,9.3c-16.2,1.3-28.2,2-28.2,2l-5.1-12.8l-13.8,5.6l16,39.9
				c0,0-139,92-143.5,95.6c-4.4,3.6-8.2,13.9,1.5,15.6s189.5,24.2,189.5,24.2" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M525.8,207.4l0.2,3.8c0,0,1.9,6.6,3.9,7c2,0.4,21.8-8.5,21.8-8.5l-3.7-8l-3.3-1.9" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="536.2,217 542.9,232.5 558.6,225.7 555.2,215 551.7,209.8" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="544.8"
                y1="232.6"
                x2="561.7"
                y2="271.6" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="557.8"
                y1="226.9"
                x2="574.5"
                y2="265.4" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M558.5,273.4c0,0,17.3-6.6,17.3-7.6c0.1-0.9-1.1-16.7-3.7-23.9c-2.7-7.2-6.8-11.9-6.8-11.9s8.7-0.7,10.7,1.7
				c1.9,2.4,4.6,22.9,5.9,30.2c1.2,7.3,2.9,16.6,5.3,23.6s30,75.9,30,75.9s21,18.1,22.5,19.7c1.5,1.6,3.6,7.8,1.2,11.1
				c-2.5,3.3-5.7,4.3-10,2.1s-18.1,5.6-18.1,5.6l-3.4-4.1l2.3-5l-48.9-111.6l-2-0.3L558.5,273.4z" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="336"
                y1="398.7"
                x2="311"
                y2="370.9" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M341.3,382.2c0,0-20.7-18.3-23-20.3c-2.3-2-7.6-1.3-8.5,3" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M389.8,450.1c-11.8-10.3-34.4-30-36.7-31.9c-2.9-2.5-6.1-10.5-0.3-15.4c5.8-4.9,12.5,0.8,12.5,0.8
				c3.9,4.3,37.9,42.2,40.4,45.5c0.2,0.2,0.4,0.5,0.5,0.7" />
            <circle
                class="fill-none stroke-woom-black stroke-2"
                cx="359.2"
                cy="410.7"
                r="6.1" />
            <rect
                x="380.7"
                y="450.1"
                class="fill-none stroke-woom-black stroke-2"
                width="40.1"
                height="9.8" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="320.2"
                y1="363.5"
                x2="336.6"
                y2="363.5" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="329.6"
                y1="371.6"
                x2="338.4"
                y2="371.6" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M434.4,312.1l-0.6,0.7c-0.1,0.2-0.3,0.2-0.5,0.1l-5.2-2.3c-1.7-0.8-3.7-0.6-5.1,1.1c-0.7,0.8-1.1,1.9-1,3
				c-1.2,0.2-2.3,0.8-2.9,1.5c-1.5,1.7-1.7,3.7-0.6,5.2c-2-0.4-4.1,0.1-5.5,1.7c-1.3,1.5-1.7,3.7-1.2,5.5c-1.9-0.4-4,0.3-5.3,1.8
				c-1.3,1.5-1.7,3.7-1.2,5.5l-1.1-0.9c-0.5-0.5-1.4-0.5-1.9,0.1c-0.5,0.5-0.5,1.5,0.1,1.9l4.4,3.9c0.7,0.6,0.5,1.6,0,2.2
				c-0.5,0.6-1.6,0.8-2.2,0.2l-0.1-0.1l-4.4-3.8c-0.5-0.5-1.4-0.5-1.9,0.1c-0.5,0.5-0.5,1.5,0.1,1.9l4.4,3.8l0.1,0.1
				c0.7,0.7,0.5,1.6,0.1,2.2c-0.5,0.5-1.1,0.7-2.1,0.4l-5.6-2.4c-1.3-0.6-2.4,0.2-2.8,0.5l-0.9,1.1c-0.5,0.5-0.5,1.4,0.1,1.9
				c0.5,0.5,1.4,0.4,1.9-0.1l0.6-0.7c0.1-0.2,0.3-0.2,0.5-0.1l5.2,2.3c1.7,0.8,3.7,0.6,5.1-1.1c0.7-0.8,1.1-1.9,1-3
				c1.2-0.2,2.3-0.8,2.9-1.5c1.5-1.7,1.7-3.7,0.6-5.2c2,0.4,4.1-0.1,5.5-1.7c1.3-1.5,1.8-3.7,1.2-5.5c1.9,0.4,4-0.3,5.3-1.8
				c1.3-1.5,1.8-3.7,1.2-5.5l1.1,0.9c0.5,0.5,1.4,0.5,1.9-0.1c0.5-0.5,0.5-1.5-0.1-1.9l-4.4-3.9c-0.7-0.6-0.5-1.6,0-2.2
				c0.5-0.6,1.6-0.8,2.2-0.2l0.1,0.1l4.4,3.8c0.5,0.5,1.4,0.5,1.9-0.1c0.5-0.5,0.5-1.5-0.1-1.9l-4.4-3.8l-0.1-0.1
				c-0.7-0.7-0.5-1.6-0.1-2.2s1.1-0.7,2.1-0.4l5.6,2.4c1.3,0.6,2.4-0.2,2.8-0.5l0.9-1.1c0.5-0.5,0.5-1.4-0.1-1.9
				C435.8,311.5,434.9,311.5,434.4,312.1z M412.9,336.2c-1.1,1.2-3,1.4-4.3,0.2s-1.4-3-0.3-4.3s3-1.4,4.3-0.3
				C413.9,333.1,414,335,412.9,336.2z M419.4,328.9c-1.1,1.2-3,1.4-4.3,0.2c-1.2-1.1-1.4-3-0.3-4.3s3-1.4,4.3-0.3
				S420.5,327.7,419.4,328.9z" />
        </g>
        <g class="saddle-normal">
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M257.2,190.7c0,0,1.5,5.4,8.1,4.5c6.6-0.9,24.1-5.8,26.1-7c2-1.2,9.4-9.6,9.9-9.8" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M272.2,190.3c0,0,10.6-4.4,15.5-6.6s9.9-5.4,19.9-7.2c9.9-1.8,19.2-2.6,21.2-3.4c2-0.8,3.4-3.5,0.1-6.9
					c-3.3-3.4-13.4-2.2-19.8-1.7c-6.4,0.5-67.2,2.1-73.8,2s-7.5,4-7.5,6.6c0,2.6,5.3,8.8,10.9,12C244.5,188.4,253.1,192.3,272.2,190.3
					z" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="272.8"
                    y1="194.5"
                    x2="292.8"
                    y2="243.6" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="285.4"
                    y1="190.5"
                    x2="304.6"
                    y2="239.7" />
            </g>
        </g>
        <g class="x-handlebar-normal">
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M500,146.7c0,0,0.6-3.8,0.4-5.6c-0.2-1.8-2-1.8-2-1.8l-0.9-2.4l0.6-1.7l-1.9-4.5l-2-1.2l-0.7-2.6l1.3-1.7
					l15.4-6.2" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M519.5,139.7c0,0-3-2.4-4.1-3.8c-1.1-1.4,0.2-2.7,0.2-2.7l-1-2.3l-1.7-0.8l7.1-1.7" />
                <circle
                    class="fill-none stroke-woom-black stroke-2"
                    cx="514.2"
                    cy="112.8"
                    r="6.6" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M521.3,122.4c-0.8,1.2-1.2,2.4-1.2,3.9c0,4.2,3.4,7.6,7.6,7.6s7.6-3.4,7.6-7.6c0,0-2.2-9.4-2.5-11
					c-0.3-1.6-3.5-3.3-4.6-3.5" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M512.5,119.1c0,0,5.2,2.2,7,2.9s7.3,1,9-4.9c1.7-5.9-2.9-8.1-3.7-8.4c-0.8-0.3-9.3-2.4-9.3-2.4" />
            </g>
        </g>
        <g class="tyres hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="168.4"
                            y1="244.7"
                            x2="168.4"
                            y2="532.1" />
                        <g>
                            <rect
                                x="160.6"
                                y="243.6"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.3" />
                        </g>
                        <g>
                            <rect
                                x="160.6"
                                y="531"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.3" />
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="635.5"
                            y1="244.7"
                            x2="635.5"
                            y2="532.1" />
                        <g>
                            <rect
                                x="627.7"
                                y="243.6"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.3" />
                        </g>
                        <g>
                            <rect
                                x="627.7"
                                y="531"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.3" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="cockpit hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="513.6"
                            y1="114"
                            x2="513.6"
                            y2="532.1" />
                        <g>
                            <rect
                                x="505.8"
                                y="112.8"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="505.8"
                                y="530.9"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="steering-angle hidden">
            <g class="inline">
                <g>
                    <polyline
                        class="h-line-miter fill-none stroke-woom-red stroke-3"
                        points="483.1,71.1 534.7,197.2 409.6,197.2" />
                </g>
                <path
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    d="M485.8,196.9c0-19.5,11.6-36.4,28.2-44" />
            </g>
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="539.6"
                                y1="204.1"
                                x2="678.1"
                                y2="525.7" />
                            <polyline
                                class="h-line fill-none stroke-woom-red stroke-3"
                                points="679.8,529.5 681.5,533.3 677.9,533.3" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="670.3"
                                y1="533.3"
                                x2="568"
                                y2="533.3" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="564.2"
                                y1="533.3"
                                x2="560.5"
                                y2="533.3" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <path
                            class="h-line fill-none stroke-woom-red stroke-3"
                            d="M626.8,530c0-1.4,0.1-2.8,0.2-4.2" />
                        <path
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            d="M628.7,515.9c3.2-11.3,10.3-21.1,19.8-27.8" />
                        <path
                            class="h-line fill-none stroke-woom-red stroke-3"
                            d="M652.8,485.7c1.2-0.7,2.4-1.4,3.7-1.9" />
                    </g>
                </g>
            </g>
        </g>
        <g class="top-tube-horizontal hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="505.6"
                            y1="132.3"
                            x2="270.6"
                            y2="132.3" />
                        <g>
                            <rect
                                x="504.3"
                                y="128.4"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="7.8" />
                        </g>
                        <g>
                            <rect
                                x="269.4"
                                y="128.4"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="7.8" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="wheelbase hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="636"
                            y1="387.7"
                            x2="168.9"
                            y2="387.7" />
                        <g>
                            <rect
                                x="634.9"
                                y="383.6"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="8.2" />
                        </g>
                        <g>
                            <rect
                                x="167.8"
                                y="383.6"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="8.2" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="seat-tube-angle hidden">
            <g class="inline">
                <polyline
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    points="299.8,244.6 404.8,532.2 156,533.3" />
            </g>
            <path
                class="h-line-miter inline fill-none stroke-woom-red stroke-3"
                d="M351.3,532.2c0-23.9,13.1-42.6,33.4-51.9" />
        </g>
        <g class="min-saddle-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="299.5"
                                y1="197.1"
                                x2="295"
                                y2="197.1" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="285.9"
                                y1="197.1"
                                x2="35.7"
                                y2="197.1" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="31.3"
                                y1="197.1"
                                x2="26.7"
                                y2="197.1" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <g>
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="13.2"
                                    y1="197.1"
                                    x2="13.2"
                                    y2="532.1" />
                                <g>
                                    <rect
                                        x="5.2"
                                        y="195.9"
                                        class="fill-woom-red stroke-woom-red"
                                        width="16"
                                        height="2.3" />
                                </g>
                                <g>
                                    <rect
                                        x="5.2"
                                        y="531"
                                        class="fill-woom-red stroke-woom-red"
                                        width="16"
                                        height="2.3" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M270.2,222.7c0,0,1.5,5.4,8.1,4.5c6.6-0.9,24.1-5.8,26.1-7c2-1.2,9.4-9.6,9.9-9.8" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M285.2,222.3c0,0,10.6-4.4,15.5-6.6s9.9-5.4,19.9-7.2c9.9-1.8,19.2-2.6,21.2-3.4c2-0.8,3.4-3.5,0.1-6.9
					c-3.3-3.4-13.4-2.2-19.8-1.7c-6.4,0.5-67.2,2.1-73.8,2s-7.5,4-7.5,6.6c0,2.6,5.3,8.8,10.9,12C257.5,220.4,266.1,224.3,285.2,222.3
					z" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="285.8"
                    y1="226.5"
                    x2="292.8"
                    y2="243.6" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="298.4"
                    y1="222.5"
                    x2="304.6"
                    y2="239.7" />
            </g>
        </g>
        <g class="max-saddle-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="13"
                            y1="139.9"
                            x2="13"
                            y2="532.1" />
                        <g>
                            <rect
                                x="5.2"
                                y="138.7"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="5.2"
                                y="530.8"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="266.7"
                            y1="139.9"
                            x2="262.6"
                            y2="139.9" />
                        <line
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            x1="254"
                            y1="139.9"
                            x2="34.6"
                            y2="139.9" />
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="30.3"
                            y1="139.9"
                            x2="26.1"
                            y2="139.9" />
                    </g>
                </g>
            </g>
            <g class="inline">
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M247.2,164.7c0,0,1.5,5.4,8.1,4.5c6.6-0.9,24.1-5.8,26.1-7c2-1.2,9.4-9.6,9.9-9.8" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M262.2,164.3c0,0,10.6-4.4,15.5-6.6s9.9-5.4,19.9-7.2c9.9-1.8,19.2-2.6,21.2-3.4c2-0.8,3.4-3.5,0.1-6.9
					c-3.3-3.4-13.4-2.2-19.8-1.7c-6.4,0.5-67.2,2.1-73.8,2s-7.5,4-7.5,6.6c0,2.6,5.3,8.8,10.9,12C234.5,162.4,243.1,166.3,262.2,164.3
					z" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="262.8"
                    y1="168.5"
                    x2="292.8"
                    y2="243.6" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="275.4"
                    y1="164.5"
                    x2="304.6"
                    y2="239.7" />
            </g>
        </g>
        <g class="crank-length hidden">
            <g class="inline">
                <line
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    x1="358.5"
                    y1="411.4"
                    x2="403.1"
                    y2="454.2" />
                <g>
                    <polygon
                        class="fill-woom-red stroke-woom-red"
                        points="352.9,415.6 362.9,405.7 364.4,407.1 354.4,417.1" />
                </g>
                <g>
                    <polygon
                        class="fill-woom-red stroke-woom-red"
                        points="397.4,458.4 407.4,448.5 408.9,449.9 398.9,459.9" />
                </g>
            </g>
        </g>
        <g class="handlebar-adjustability hidden">
            <g class="inline">
                <polyline
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    points="555.2,119.6 499.4,135 532.6,88.2" />
            </g>
            <path
                class="h-line-miter inline fill-none stroke-woom-red stroke-3"
                d="M513.4,115.2c8,1.4,10.4,5,9.5,12.8" />
        </g>
        <g class="stand-over-height hidden">
            <g>
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="18.2"
                            y1="220.3"
                            x2="18.2"
                            y2="532.1" />
                        <g>
                            <rect
                                x="10"
                                y="219"
                                class="fill-woom-red stroke-woom-red"
                                width="16.4"
                                height="2.5" />
                        </g>
                        <g>
                            <rect
                                x="10"
                                y="530.8"
                                class="fill-woom-red stroke-woom-red"
                                width="16.4"
                                height="2.5" />
                        </g>
                    </g>
                </g>
            </g>
            <g>
                <g>
                    <g>
                        <g>
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="396.5"
                                y1="220.2"
                                x2="41.1"
                                y2="220.2" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="36.2"
                                y1="220.2"
                                x2="31.7"
                                y2="220.2" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>
